import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductMeasurements } from '../../../../actions/product/productMeasurementList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductMeasurementListState } from '../../../../reducers/product/productMeasurementList'
import { Button, Stack } from '@mui/material'
import ProductMeasurement from '../../../../models/ProductMeasurement'
import ProductMeasurements from '../ProductMeasurements'

interface Props {
  fullInfo?: boolean
  productMeasurementList: ProductMeasurementListState
}

const ProductMeasurementList: React.FC<Props> = ({ productMeasurementList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductMeasurements(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductMeasurementEdit = (productMeasurement: ProductMeasurement) => {
    const editUrl = `/admin/productMeasurements/update/${productMeasurement.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductMeasurements
        rows={(productMeasurementList.productMeasurements || []).map(s => ({ data: s }))}
        loading={productMeasurementList.isFetching}
        pagination={productMeasurementList.pagination || undefined}
        onClickInfo={linkToProductMeasurementEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productMeasurements/create', { title: t('create') })}>
        {`${t('create')}${t('measurement')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productMeasurementList: state.productMeasurementList,
})

export default connect(mapStateToProps, null)(ProductMeasurementList)